import { PermissionScope } from './permission-scopes.model';
import { Role } from './role.model';
import { PERMISSIONS } from '../../Enums/permission.enum';
import { EntitlementMap } from '../../Interfaces/api/entitlements.interface';
import { UserLicence } from '../../Interfaces/api/licences.interface';
import { LicenceState } from '../../Types/licence-state.type';

export class User {
  id?: string;
  email?: string;
  first_name?: string;
  last_name?: string;
  preferred_lang?: string;
  preferred_theme?: string;
  organization_id?: string;
  role_id?: string;

  // Intune fields
  intune_user_id?: string;
  displayName?: string;
  mobilePhone?: string;
  businessPhones?: string[];
  jobTitle?: string;
  officeLocation?: string;
  preferredLanguage?: string;
  userPrincipalName?: string;
  employeeId?: string;
  photo: string | null = null;

  created_at?: string;
  updated_at?: string;

  role?: Role;
  permission_scopes?: PermissionScope[];
  entitlements?: EntitlementMap;

  // Licence
  licence_state?: LicenceState;
  licence?: UserLicence | null;

  constructor(init?: Partial<User>) {
    Object.assign(this, init);
  }

  public get licenceEndsAt(): string | null {
    return this.licence?.cancels_at ?? null;
  }

  public get name(): string {
    return `${this.first_name ?? ''} ${this.last_name ?? ''}`.trim();
  }

  public hasPermission(required: PERMISSIONS | PERMISSIONS[]): boolean {
    const userPermissions = this.role?.permissions ?? [];
    const required_arr = Array.isArray(required) ? required : [required];
    return required_arr.some(rp => userPermissions.some(p => p.name === rp));
  }

  public hasEntitlement(key: string): boolean {
    if (this.entitlements === undefined) {
      return true;
    }

    return this.entitlements[key] === true;
  }
}
